import { Component } from '@angular/core';
import { ReliabilityWidgetComponent } from '../widgets/reliability-widget/reliability-widget.component';
import { ReliabilityOverviewWidgetComponent } from '../widgets/reliability-overview-widget/reliability-overview-widget.component';

@Component({
    selector: 'tgrid-statewide-reliability-page',
    templateUrl: './statewide-reliability-page.component.html',
    styleUrls: ['./statewide-reliability-page.component.scss'],
    imports: [ReliabilityWidgetComponent, ReliabilityOverviewWidgetComponent], 
})
export class StatewideReliabilityPageComponent {
}